import React, {useCallback, useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';


export const AgentInputArea = ({value, onChange, onSend, disabled}) => {
    const {t} = useTranslation();
    const textareaRef = useRef(null);

    const autoResize = useCallback(() => {
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = 'auto';
        const lineHeight = 20;
        const maxHeight = lineHeight * 6 + 16; // 6 lineas + padding
        el.style.height = Math.min(el.scrollHeight, maxHeight) + 'px';
    }, []);

    useEffect(() => {
        autoResize();
    }, [value, autoResize]);

    const handleKeyDown = useCallback((e) => {
        if (e.ctrlKey && e.key === 'Enter') {
            e.preventDefault();
            if (!disabled && value.trim()) {
                onSend();
            }
        }
    }, [disabled, value, onSend]);

    const canSend = !disabled && value.trim().length > 0;

    return (
        <div className="agent-input">
            <div className="agent-input__wrapper">
                <textarea
                    ref={textareaRef}
                    className="agent-input__textarea"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={t('agent_chat.placeholder')}
                    rows={1}
                    disabled={disabled}
                />
                <button
                    className={`agent-input__send-btn ${canSend ? '' : 'agent-input__send-btn--disabled'}`}
                    onClick={onSend}
                    disabled={!canSend}
                    aria-label={t('agent_chat.send')}
                >
                    <i className="fas fa-paper-plane"></i>
                </button>
            </div>
            <span className="agent-input__hint">Ctrl+Enter</span>
        </div>
    );
};
